export interface LoadedImageDimensionsInterface {
  width: number
  height: number
}

export const loadImageDimensions = (
  imagePath: string,
  onLoad: (dimensions: LoadedImageDimensionsInterface) => void,
) => {
  const image = new Image()
  image.src = imagePath
  image.onload = () => {
    const width = image.naturalWidth || image.width
    const height = image.naturalHeight || image.height

    if (width > 0 && height > 0) {
      onLoad({ width, height })
    }
  }
}

export const calculateImageRatio = ({
  width,
  height,
}: LoadedImageDimensionsInterface): number | undefined => {
  const ratio = Number((width / height).toFixed(2))
  return Number.isFinite(ratio) ? ratio : undefined
}
